module.exports = __webpack_public_path__ + "img/icon_subject.8407ee69.png";